export async function unwrap(res) {
  const response = await res;
  if (response instanceof Response) {
    return await response.json();
  }
  return response;
}
